var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "position-relative",
      class: {
        "object-container-automation": !_vm.onProperties,
        "object-active": _vm.blockActive
      },
      staticStyle: { cursor: "default" },
      on: { mouseover: _vm.pauseZoom, mouseleave: _vm.resumeZoom }
    },
    [
      _vm.onProperties
        ? _c(
            "div",
            { staticClass: "toggle-disable-block" },
            [
              _c("j-switch", {
                model: {
                  value: _vm.disable_block,
                  callback: function($$v) {
                    _vm.disable_block = $$v
                  },
                  expression: "disable_block"
                }
              }),
              _vm._v(" "),
              _c("div", { staticClass: "tooltip-toggle-disable" }, [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.disable_block ? "Disable" : "Enable") +
                    " this block\n    "
                )
              ])
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties
        ? [
            _c("img", {
              staticClass: "m__r--5",
              attrs: {
                src: require("@/assets/automation/trigger.svg"),
                width: "20",
                height: "20"
              }
            }),
            _vm._v(" "),
            _c("span", { staticClass: "title-automation m__r--5" }, [
              _vm._v("TRIGGER")
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "id-block-automation" }, [
              _vm._v(
                _vm._s(_vm.data_trigger.id ? "#" + _vm.data_trigger.id : "")
              )
            ])
          ]
        : _vm._e(),
      _vm._v(" "),
      !_vm.onProperties
        ? _c("img", {
            staticClass: "pull-right cursor-pointer",
            attrs: {
              src: require("@/assets/automation/config.svg"),
              width: "20",
              height: "20"
            },
            on: { click: _vm.showProperties }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.onProperties
        ? _c(
            "div",
            [
              _c("div", { staticClass: "sub-header-properties-wrap" }, [
                _c("img", {
                  attrs: {
                    src: require("@/assets/automation/" +
                      _vm.selectedObject.img +
                      ".svg"),
                    width: "25"
                  }
                }),
                _vm._v(" "),
                _c("div", { staticClass: "text-object" }, [
                  _vm._v(" " + _vm._s(_vm.selectedObject.title) + " ")
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "section-border mb-3" },
                [
                  _c(
                    "b-form-group",
                    { class: { "error-input": _vm.$v.name_automation.$error } },
                    [
                      _c("label", { attrs: { for: "name" } }, [
                        _vm._v(" Name ")
                      ]),
                      _vm._v(" "),
                      _c("j-input", {
                        attrs: {
                          id: "name",
                          "error-required": _vm.$v.name_automation.$error,
                          placeholder: "Type visual programming name"
                        },
                        model: {
                          value: _vm.$v.name_automation.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.name_automation, "$model", $$v)
                          },
                          expression: "$v.name_automation.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-form-group",
                    { class: { "error-input": _vm.$v.description.$error } },
                    [
                      _c("label", { attrs: { for: "description" } }, [
                        _vm._v(" Description ")
                      ]),
                      _vm._v(" "),
                      _c("j-textarea", {
                        attrs: {
                          "error-required": _vm.$v.description.$error,
                          "max-length": 255,
                          placeholder: "Type visual programming description"
                        },
                        model: {
                          value: _vm.$v.description.$model,
                          callback: function($$v) {
                            _vm.$set(_vm.$v.description, "$model", $$v)
                          },
                          expression: "$v.description.$model"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.data_trigger.object === "form"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.table_group.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Table Group ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger.table_group
                                              .$error,
                                          options: _vm.tableGroupOptions,
                                          placeholder: "Select Table Group",
                                          "value-format": "object",
                                          label: "name"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger.table_group
                                              .$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.table_group,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.table_group.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.form.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Table ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger.form.$error,
                                          disabled: !_vm.data_trigger
                                            .table_group,
                                          options: _vm.tableOptions,
                                          placeholder: "Select Table",
                                          "value-format": "object",
                                          label: "name"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger.form.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.form,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.form.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.event.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Event ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger.event.$error,
                                          options: _vm.eventOptions,
                                          placeholder: "Event"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger.event.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.event,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.event.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          (_vm.data_trigger.form
                          ? _vm.data_trigger.form.is_share_device_info
                          : false)
                            ? _c(
                                "label",
                                { staticStyle: { color: "#42a5ce" } },
                                [
                                  _vm._v(
                                    "\n          Allow to share device info"
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_trigger.object === "scheduller"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.every_int.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Every ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "max-length": 255,
                                          type: "number"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger.every_int
                                              .$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.every_int,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.every_int.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.every.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Every ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger.every.$error,
                                          options: _vm.everyOptions,
                                          placeholder: "Select"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger.every.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.every,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.every.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "b-col",
                                { attrs: { md: "4" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.at.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" At ")]),
                                      _vm._v(" "),
                                      _c("j-clockpicker", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger.at.$error
                                        },
                                        model: {
                                          value: _vm.$v.data_trigger.at.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.at,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.at.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_trigger.object === "event"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.event_name.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Event Name ")]),
                                      _vm._v(" "),
                                      _c("j-single-select", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger.event_name
                                              .$error,
                                          options: _vm.optionEventName,
                                          placeholder: "Select"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger.event_name
                                              .$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.event_name,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.event_name.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_trigger.object === "function"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.function_name
                                            .$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Function Name ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger.function_name
                                              .$error,
                                          "max-length": 255,
                                          placeholder:
                                            "Only lowercase characters and underscore '_' are allowed, ex: name_function"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger.function_name
                                              .$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.function_name,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.function_name.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_trigger.object === "job"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.job_name.$error
                                      }
                                    },
                                    [
                                      _c("label", [_vm._v(" Job Name ")]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger.job_name.$error,
                                          "max-length": 255,
                                          placeholder:
                                            "Only lowercase characters and underscore '_' are allowed, ex: name_job"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger.job_name.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger.job_name,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.job_name.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_trigger.object === "dedicated_job"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-row",
                            [
                              _c(
                                "b-col",
                                { attrs: { md: "12" } },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      class: {
                                        "error-input":
                                          _vm.$v.data_trigger.dedicated_job_name
                                            .$error
                                      }
                                    },
                                    [
                                      _c("label", [
                                        _vm._v(" Dedicated Job Name ")
                                      ]),
                                      _vm._v(" "),
                                      _c("j-input", {
                                        attrs: {
                                          "error-required":
                                            _vm.$v.data_trigger
                                              .dedicated_job_name.$error,
                                          "max-length": 255,
                                          placeholder:
                                            "Only lowercase characters and underscore '_' are allowed, ex: name_dedicated_job"
                                        },
                                        model: {
                                          value:
                                            _vm.$v.data_trigger
                                              .dedicated_job_name.$model,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.$v.data_trigger
                                                .dedicated_job_name,
                                              "$model",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "$v.data_trigger.dedicated_job_name.$model"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.data_trigger.object === "api" ||
                  _vm.data_trigger.object === "api_v2" ||
                  _vm.data_trigger.object === "webhook" ||
                  _vm.data_trigger.object === "webhook_v2"
                    ? _c(
                        "div",
                        [
                          _c(
                            "b-form-group",
                            {
                              class: {
                                "error-input": _vm.$v.data_trigger.url.$error
                              }
                            },
                            [
                              _c("div", { staticClass: "d-flex m__t--10" }, [
                                _c("div", { staticClass: "label-url-api" }, [
                                  _vm._v(" Url ")
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "base-url-api" }, [
                                  _vm._v(_vm._s(_vm.url))
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "container-value-api" },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "method cursor-pointer",
                                      on: {
                                        click: function($event) {
                                          _vm.openListMethod = !_vm.openListMethod
                                        }
                                      }
                                    },
                                    [_vm._v(_vm._s(_vm.data_trigger.method))]
                                  ),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass:
                                      "fa fa-chevron-down cursor-pointer",
                                    on: {
                                      click: function($event) {
                                        _vm.openListMethod = !_vm.openListMethod
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.openListMethod
                                    ? _c(
                                        "div",
                                        { staticClass: "selections-method" },
                                        _vm._l(_vm.methodOptions, function(
                                          option
                                        ) {
                                          return _c(
                                            "div",
                                            {
                                              key: option.id,
                                              staticClass: "option",
                                              on: {
                                                click: function($event) {
                                                  _vm.data_trigger.method =
                                                    option.id
                                                  _vm.openListMethod = false
                                                }
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(_vm._s(option.text))
                                              ])
                                            ]
                                          )
                                        })
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("j-input", {
                                    attrs: { "max-length": 255 },
                                    model: {
                                      value: _vm.$v.data_trigger.url.$model,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.$v.data_trigger.url,
                                          "$model",
                                          $$v
                                        )
                                      },
                                      expression: "$v.data_trigger.url.$model"
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c("i", {
                                    staticClass: "fa fa-clone copy-url",
                                    on: { click: _vm.copyToClipboard }
                                  })
                                ],
                                1
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "section-border mt-3 mb-4" }, [
                _c("p", { staticClass: "title-section" }, [
                  _vm._v("Configuration")
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "config-toggle" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c("j-switch", {
                      model: {
                        value: _vm.disable_run_history,
                        callback: function($$v) {
                          _vm.disable_run_history = $$v
                        },
                        expression: "disable_run_history"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.data_trigger.object === "api_v2"
                  ? _c("div", { staticClass: "config-toggle d-block" }, [
                      _c(
                        "div",
                        { staticClass: "d-flex justify-content-between" },
                        [
                          _vm._m(1),
                          _vm._v(" "),
                          _c("j-switch", {
                            model: {
                              value: _vm.data_trigger.is_rate_limits,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.data_trigger,
                                  "is_rate_limits",
                                  $$v
                                )
                              },
                              expression: "data_trigger.is_rate_limits"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.data_trigger.is_rate_limits
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "container-value-api container-value-api__maximum"
                            },
                            [
                              _c("div", { staticClass: "label" }, [
                                _vm._v("Maximum Request")
                              ]),
                              _vm._v(" "),
                              _c("j-input", {
                                staticClass: "input-maximum",
                                attrs: { type: "number" },
                                model: {
                                  value: _vm.data_trigger.rate_limits,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.data_trigger,
                                      "rate_limits",
                                      $$v
                                    )
                                  },
                                  expression: "data_trigger.rate_limits"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "base-url-api tag-label" },
                                [_vm._v("per seconds")]
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.showSwitcherService
                  ? _c("div", { staticClass: "config-toggle" }, [
                      _c("div", { staticClass: "wrap-config-toggle-desc" }, [
                        _c("p", { staticClass: "title-config-toggle" }, [
                          _vm._v("Specific Run Service")
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "container-value-api container-value-api__maximum"
                          },
                          [
                            _c("div", { staticClass: "label" }, [
                              _vm._v("Service")
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "label-border-left cursor-pointer",
                                on: {
                                  click: function($event) {
                                    _vm.openListSerive = !_vm.openListSerive
                                  }
                                }
                              },
                              [_vm._v(_vm._s(_vm.nocodeServiceTarget))]
                            ),
                            _vm._v(" "),
                            _c("i", {
                              staticClass: "fa fa-chevron-down cursor-pointer",
                              on: {
                                click: function($event) {
                                  _vm.openListSerive = !_vm.openListSerive
                                }
                              }
                            }),
                            _vm._v(" "),
                            _vm.openListSerive
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "selections-method selections-service"
                                  },
                                  _vm._l(_vm.serviceOptions, function(option) {
                                    return _c(
                                      "div",
                                      {
                                        key: option.id,
                                        staticClass: "option",
                                        on: {
                                          click: function($event) {
                                            _vm.nocodeServiceTarget = option
                                            _vm.openListSerive = false
                                          }
                                        }
                                      },
                                      [_c("span", [_vm._v(_vm._s(option))])]
                                    )
                                  })
                                )
                              : _vm._e()
                          ]
                        ),
                        _vm._v(" "),
                        _c("p", { staticClass: "desc-config-toggle m__t--5" }, [
                          _vm._v(
                            "\n            For running process on specific service\n          "
                          )
                        ])
                      ])
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c("hr"),
              _vm._v(" "),
              _c("span", { staticClass: "title-automation" }, [
                _vm._v("Container Variable")
              ]),
              _vm._v(" "),
              _c(
                "b-form-group",
                {
                  class: {
                    "error-input": _vm.$v.data_trigger.variable_name.$error
                  }
                },
                [
                  _c("label", [_vm._v(" Request ")]),
                  _vm._v(" "),
                  _c("j-input", {
                    attrs: {
                      "error-required":
                        _vm.$v.data_trigger.variable_name.$error,
                      "max-length": 255,
                      placeholder: "Variable Name"
                    },
                    model: {
                      value: _vm.$v.data_trigger.variable_name.$model,
                      callback: function($$v) {
                        _vm.$set(
                          _vm.$v.data_trigger.variable_name,
                          "$model",
                          $$v
                        )
                      },
                      expression: "$v.data_trigger.variable_name.$model"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _vm.data_trigger.object === "api" ||
              _vm.data_trigger.object === "api_v2" ||
              _vm.data_trigger.object === "webhook" ||
              _vm.data_trigger.object === "webhook_v2" ||
              _vm.data_trigger.object === "function"
                ? _c(
                    "div",
                    [
                      _c(
                        "b-form-group",
                        {
                          class: {
                            "error-input":
                              _vm.$v.data_trigger.variable_response.$error
                          }
                        },
                        [
                          _c("label", [_vm._v(" Response ")]),
                          _vm._v(" "),
                          _c("j-input", {
                            attrs: {
                              "error-required":
                                _vm.$v.data_trigger.variable_response.$error,
                              "max-length": 255,
                              placeholder: "Variable Name"
                            },
                            model: {
                              value:
                                _vm.$v.data_trigger.variable_response.$model,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.$v.data_trigger.variable_response,
                                  "$model",
                                  $$v
                                )
                              },
                              expression:
                                "$v.data_trigger.variable_response.$model"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        : _c(
            "div",
            [
              _vm.showContainer
                ? _c(
                    "b-row",
                    { staticClass: "m__t--10 m__b--10" },
                    [
                      _c(
                        "b-col",
                        { staticClass: "p__r--1", attrs: { md: "2" } },
                        [
                          _vm.dataEdit.trigger.type === "form"
                            ? _c("img", {
                                staticClass: "m__t--5",
                                attrs: {
                                  src: require("@/assets/automation/data_manager.svg"),
                                  width: "35",
                                  height: "35"
                                }
                              })
                            : _vm.dataEdit.trigger.type === "event"
                            ? _c("img", {
                                staticClass: "m__t--5",
                                attrs: {
                                  src: require("@/assets/automation/event.svg"),
                                  width: "35",
                                  height: "35"
                                }
                              })
                            : _vm.dataEdit.trigger.type === "function"
                            ? _c("img", {
                                staticClass: "m__t--5",
                                attrs: {
                                  src: require("@/assets/automation/function.svg"),
                                  width: "35",
                                  height: "35"
                                }
                              })
                            : _vm.dataEdit.trigger.type === "job" ||
                              _vm.dataEdit.trigger.type === "dedicated_job"
                            ? _c("img", {
                                staticClass: "m__t--5",
                                attrs: {
                                  src: require("@/assets/automation/job.svg"),
                                  width: "35",
                                  height: "35"
                                }
                              })
                            : _c("img", {
                                attrs: {
                                  src: require("@/assets/automation/api.svg"),
                                  width: "35",
                                  height: "35"
                                }
                              })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.dataEdit.trigger.type === "form"
                        ? _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "10" } },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "trigger__label-form ellipsis m__l--10"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.data_trigger.form
                                          ? _vm.data_trigger.form.name
                                          : ""
                                      ) +
                                      "\n        "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "trigger__label-event ellipsis m__l--10"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.eventLabel) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm.dataEdit.trigger.type === "event"
                        ? _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "10" } },
                            [
                              _c(
                                "div",
                                { staticClass: "trigger__label-form m__l--10" },
                                [_vm._v("\n          Event\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "trigger__label-event ellipsis m__l--10"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.data_trigger.event_name) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm.dataEdit.trigger.type === "function"
                        ? _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "10" } },
                            [
                              _c(
                                "div",
                                { staticClass: "trigger__label-form m__l--10" },
                                [_vm._v("\n          Function\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "trigger__label-event ellipsis m__l--10"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.data_trigger.function_name) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm.dataEdit.trigger.type === "job"
                        ? _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "10" } },
                            [
                              _c(
                                "div",
                                { staticClass: "trigger__label-form m__l--10" },
                                [_vm._v("\n          Job\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "trigger__label-event ellipsis m__l--10"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.data_trigger.job_name) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm.dataEdit.trigger.type === "dedicated_job"
                        ? _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "10" } },
                            [
                              _c(
                                "div",
                                { staticClass: "trigger__label-form m__l--10" },
                                [_vm._v("\n          Dedicated Job\n        ")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "trigger__label-event ellipsis m__l--10"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.data_trigger.dedicated_job_name
                                      ) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          )
                        : _c(
                            "b-col",
                            { staticClass: "p__l--1", attrs: { md: "10" } },
                            [
                              _c(
                                "div",
                                { staticClass: "trigger__label-form m__l--10" },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(
                                        _vm.dataEdit.trigger.type.includes(
                                          "webhook"
                                        )
                                          ? "Webhook"
                                          : "API"
                                      ) +
                                      "\n          "
                                  ),
                                  _vm.data_trigger.method
                                    ? _c(
                                        "span",
                                        { staticClass: "trigger__label-api" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.data_trigger.method.toUpperCase()
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "trigger__label-event ellipsis m__l--10"
                                },
                                [
                                  _vm._v(
                                    "\n          " +
                                      _vm._s(_vm.url) +
                                      _vm._s(_vm.data_trigger.url) +
                                      "\n        "
                                  )
                                ]
                              )
                            ]
                          )
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.showContainer
                ? _c(
                    "div",
                    { staticClass: "trigger__label-variable ellipsis" },
                    [
                      _c("img", {
                        staticClass: "m__r--10",
                        attrs: {
                          src: require("@/assets/automation/variable.png"),
                          width: "20",
                          height: "20"
                        }
                      }),
                      _vm._v(
                        "\n      " +
                          _vm._s(_vm.data_trigger.variable_name) +
                          "\n    "
                      )
                    ]
                  )
                : _vm._e()
            ],
            1
          )
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-config-toggle-desc" }, [
      _c("p", { staticClass: "title-config-toggle" }, [
        _vm._v("Disable Run History")
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config-toggle" }, [
        _vm._v(
          "\n            To improve performance, the result of the all blocks will be disabled in the run history. Container variables can still be used to store block execution results.\n          "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "wrap-config-toggle-desc" }, [
      _c("p", { staticClass: "title-config-toggle" }, [_vm._v("Rate Limits")]),
      _vm._v(" "),
      _c("p", { staticClass: "desc-config-toggle" }, [
        _vm._v(
          "\n              Rate limit is a restriction on the number of requests within a specific time period to prevent resource abuse and maintain system performance.\n            "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7d7e42f4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d7e42f4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/visual-programming/jVPBlockTrigger.vue
// module id = null
// module chunks = 